import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ModalBg } from 'assets/images';

import './style.scss';

const CustomModal = ({ show, onClose, title, subTitle }) => {
  const { t } = useTranslation();
  return (
    <Modal backdrop="static" centered className="custom-modal-container" keyboard={false} onHide={onClose} show={show}>
      <div className="modal-bg" style={{ backgroundImage: `url(${ModalBg})` }}>
        <div className="modal-inner-content d-flex flex-column align-items-center justify-content-center">
          <p className="modal-text">{title}</p>
          {subTitle ? <p className="modal-text">{subTitle}</p> : null}
          <button className="modal-ok-btn" onClick={onClose} type="button">
            {t('customModal.okay')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
